import { Component, Input } from '@angular/core';
import { IProject } from '../../../_data/projects';

@Component({
  selector: 'app-portfolio-project-preview',
  templateUrl: './portfolio-project-preview.component.html',
  styleUrls: ['./portfolio-project-preview.component.scss'],
})
export class PortfolioProjectPreviewComponent {
  @Input() project: IProject;
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/portfolio-project-preview/portfolio-project-preview.component.ts